module.exports = __webpack_public_path__ + "img/un-battant.92d353b.svg";